export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7198.09fa5472.jpg";